import React from "react";
import {getPeopleSubNavLinks} from "../../page_components/PeoplePage/subNavLinks";
import BasePage from "../../page_components/BasePage/BasePage";
import InMemoriamLandingPageContent
    from "../../page_components/LandingPage/InMemoriamLandingPage/InMemoriamLandingPageContent/InMemoriamLandingPageContent";
import {graphql} from "gatsby";

export const query = graphql`
    {
      editorials: allEditorial(filter: {pageCategory: {eq: "in-memoriam"}}) {
          nodes {
              ...EditorialFragment
          }
      }
    }
`

const InMemoriamLandingPage = ({data: {editorials}}) => {
    const subNavLinks = getPeopleSubNavLinks()
    return (
        <BasePage subNavLinks={subNavLinks}>
            <InMemoriamLandingPageContent articles={editorials.nodes} title="In Memoriam">
                We pay tribute to industry luminaries we lost this year.
            </InMemoriamLandingPageContent>
        </BasePage>
    )
}

export default InMemoriamLandingPage;